import { useEffect, useState } from "react";

/**
 * Tracks the user's prefers-reduced-motion media query.
 * Defaults to false on the server / before mount.
 *
 * A platform without `matchMedia` is left at false rather than throwing: jsdom
 * has none unless a test supplies one, and a component that only animates has
 * no business failing to render because of it.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => {
      setReduced(media.matches);
    };
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  return reduced;
}
